import { NotificationFeed } from './NotificationFeed';

/**
 * Drawer body shared by the desktop popover and the mobile bottom-sheet. The
 * full enrichment (header pill, search, tabs, recency buckets) lives in
 * {@link NotificationFeed}. The responsive split (Popover vs BottomSheet) is
 * decided by the bell.
 *
 * Opening a row keeps the panel open on BOTH form factors — the detail
 * pop-up (dialog on desktop, sheet on mobile) stacks above it, so dismissing
 * the detail drops the user back on the list instead of forcing a bell
 * round-trip for every message.
 */
export function NotificationsPanel() {
  return (
    <div className="max-h-[80vh] w-full" data-testid="notification-panel">
      <NotificationFeed />
    </div>
  );
}
